import React from "react";

// SVG-only animated molecular / helix backdrop. No heavy libs.
export const HeroBackground = () => {
  const nodes = [
    { cx: 12, cy: 22, r: 2.2 },
    { cx: 26, cy: 14, r: 1.6 },
    { cx: 40, cy: 26, r: 2.0 },
    { cx: 58, cy: 18, r: 1.4 },
    { cx: 72, cy: 30, r: 2.2 },
    { cx: 84, cy: 20, r: 1.6 },
    { cx: 20, cy: 60, r: 1.8 },
    { cx: 36, cy: 72, r: 2.4 },
    { cx: 52, cy: 62, r: 1.6 },
    { cx: 70, cy: 74, r: 2.0 },
    { cx: 88, cy: 66, r: 1.5 },
  ];
  const links = [
    [0, 1], [1, 2], [2, 3], [3, 4], [4, 5],
    [6, 7], [7, 8], [8, 9], [9, 10],
    [2, 7], [4, 9], [1, 6], [5, 10],
  ];
  return (
    <div className="absolute inset-0 overflow-hidden pointer-events-none">
      {/* Grid */}
      <div className="absolute inset-0 grid-backdrop opacity-60" />

      {/* Radial glow */}
      <div className="absolute inset-0 vignette-radial" />

      {/* Helix SVG */}
      <svg
        className="absolute inset-0 w-full h-full opacity-90"
        viewBox="0 0 100 100"
        preserveAspectRatio="none"
      >
        <defs>
          <linearGradient id="lineGrad" x1="0" y1="0" x2="1" y2="0">
            <stop offset="0%" stopColor="#1565FF" stopOpacity="0" />
            <stop offset="50%" stopColor="#1565FF" stopOpacity="0.55" />
            <stop offset="100%" stopColor="#1565FF" stopOpacity="0" />
          </linearGradient>
          <radialGradient id="dotGlow" cx="50%" cy="50%" r="50%">
            <stop offset="0%" stopColor="#1565FF" stopOpacity="0.9" />
            <stop offset="100%" stopColor="#1565FF" stopOpacity="0" />
          </radialGradient>
        </defs>

        {/* Double helix strands */}
        <path
          d="M0,50 C 12,30 24,70 36,50 C 48,30 60,70 72,50 C 84,30 96,70 108,50"
          fill="none"
          stroke="url(#lineGrad)"
          strokeWidth="0.35"
        />
        <path
          d="M0,50 C 12,70 24,30 36,50 C 48,70 60,30 72,50 C 84,70 96,30 108,50"
          fill="none"
          stroke="url(#lineGrad)"
          strokeWidth="0.35"
        />

        {/* Peptide bond links */}
        {links.map(([a, b], i) => (
          <line
            key={i}
            x1={nodes[a].cx}
            y1={nodes[a].cy}
            x2={nodes[b].cx}
            y2={nodes[b].cy}
            stroke="#1565FF"
            strokeOpacity="0.18"
            strokeWidth="0.15"
          />
        ))}

        {/* Nodes */}
        {nodes.map((n, i) => (
          <g key={i}>
            <circle cx={n.cx} cy={n.cy} r={n.r * 1.8} fill="url(#dotGlow)" />
            <circle cx={n.cx} cy={n.cy} r={n.r * 0.35} fill="#1565FF" />
          </g>
        ))}
      </svg>

      {/* Floating particles */}
      <div className="absolute left-[8%] top-[30%] mol-dot animate-float-y" style={{ animationDelay: "0s" }} />
      <div className="absolute left-[80%] top-[24%] mol-dot animate-float-y" style={{ animationDelay: "1.5s" }} />
      <div className="absolute left-[60%] top-[70%] mol-dot animate-float-y" style={{ animationDelay: "0.8s" }} />
      <div className="absolute left-[20%] top-[75%] mol-dot animate-float-y" style={{ animationDelay: "2.2s" }} />

      {/* Grain */}
      <div className="absolute inset-0 grain" />
    </div>
  );
};
